import relatedCategoryFeaturedStores from './relatedCategoryFeaturedStores';

export default relatedCategoryFeaturedStores;
